import { createApi } from '@reduxjs/toolkit/query/react';
import { endPoints, urlKeys } from 'src/api/APIEndpoints';
import { HTTPValidationError, ISuccessfulResponse } from 'src/types/SiteStudyPersonal';
import { formatString } from 'src/util/STR';
import { baseQuery } from './baseQuery';
import { workareaBaseQuery } from './workArearBaseQuery';

export const siteContactInfoApi = createApi({
  baseQuery,
  reducerPath: 'siteContactInfoApi',
  endpoints: builder => ({
    getSiteStudyPersonnelData: builder.query<any, any>({
      query: ({
        site_id,
        study_id,
        country,
        application,
        site_users = false,
        strictly_site_users = false,
        sponsor_users = false
      }) => ({
        url: `${formatString(
          endPoints.SiteStudyPersonnel.siteStudyPersonnelSelect,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&application=${application}&site_contact_info=true&site_users=${site_users}&strictly_site_users=${strictly_site_users}&sponsor_users=${sponsor_users}`,
        method: 'GET'
      }),
      extraOptions: { maxRetries: 3 }
    })
  })
});
export const siteContactInfoSysAdminApi = createApi({
  baseQuery: workareaBaseQuery,
  reducerPath: 'siteContactInfoSysAdminApi',
  endpoints: builder => ({
    UpdateSitePersonal: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, data, application }) => ({
        url: `${formatString(
          endPoints.SiteStudyPersonnel.update
        )}?study_id=${study_id}&site_id=${site_id}&country=${country}&application=CTMS`,
        method: 'PUT',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    UpdateSitePersonalFics: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, data, application }) => ({
        url: `${formatString(
          endPoints.SiteStudyPersonnel.updateFics
        )}?study_id=${study_id}&site_id=${site_id}&country=${country}&application=CTMS`,
        method: 'PUT',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    createSitePersonal: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, data, application }) => ({
        url: `${formatString(endPoints.SiteStudyPersonnel.create, {
          key: urlKeys.study_id,
          value: study_id
        })}?site_id=${site_id}&country=${country}&application=CTMS`,
        method: 'POST',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    createUserClick: builder.mutation<ISuccessfulResponse | HTTPValidationError, { data: any }>({
      query: ({ data }) => ({
        url: formatString(endPoints.UserClicks.create),
        method: 'PUT',
        body: data
      }),
      extraOptions: { maxRetries: 3 } //add this for retry option
    }),
    UpdateSiteInfo: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, data, application }) => ({
        url: `${formatString(endPoints.siteInfo.update, {
          key: urlKeys.site_id,
          value: site_id
        })}?study_id=${study_id}&country=${country}&application=${application}`,
        method: 'PUT',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    UpdateStudyIdentified: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, data, application }) => ({
        url: `${formatString(
          endPoints.siteInfo.updateStudyIdentified,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&application=${application}`,
        method: 'PUT',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    deleteSitePersonnel: builder.mutation<any, any>({
      query: ({ personnel_id, study_id, country, data, appName, site_id }) => ({
        url: `${formatString(endPoints.Personnel.delete, {
          key: 'personnel_id',
          value: personnel_id
        })}?study_id=${study_id}&site_id=${site_id}country=${country}&application=${appName}`,
        method: 'PATCH',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    })
  })
});
export const { useLazyGetSiteStudyPersonnelDataQuery } = siteContactInfoApi;
export const {
  useCreateSitePersonalMutation,
  useUpdateSitePersonalMutation,
  useUpdateSitePersonalFicsMutation,
  useCreateUserClickMutation,
  useUpdateSiteInfoMutation,
  useUpdateStudyIdentifiedMutation,
  useDeleteSitePersonnelMutation
} = siteContactInfoSysAdminApi;
